import React from "react";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
			height: "100%",
			textAlign: "right",
			flexShrink: 0,
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		value: {
			fontFamily: theme.fonts.medium,
			fontSize: "36px",
			lineHeight: 1,
			color: theme.palette.colors.charcoalGrey,
			marginBottom: "auto",
			marginTop: "1px",
		},
		valueText: {
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			textAlign: "center",
			lineHeight: 1,
			color: theme.palette.colors.charcoalGrey,
			marginBottom: "auto",
			marginTop: "1px",
			marginLeft: "2px",
		},
		text: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: 1.29,
			color: theme.palette.colors.oneMoreGrey,
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			value: {
				fontSize: "24px",
			},
			text: {
				lineHeight: "0.8",
			},
			valueText: {
				fontSize: "14px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			value: {
				fontSize: "24px",
			},
			text: {
				lineHeight: "0.8",
				fontSize: "12px",
			},
			valueText: {
				fontSize: "12px",
			},
		},
	};
};

const RatingPlace = ({ classes, text, position, rating }) => {
	let ratingValue = rating;
	let ratingClass = classes.value;

	if (rating === "0.0") {
		ratingValue = text.NOT_ENOUGH_REVIEWS;
		ratingClass = classes.valueText;
	}

	return (
		<div className={classes.root}>
			<div className={ratingClass}>{ratingValue}</div>
			<div className={classes.text}>{`${position} ${text.PLACEMENT}`}</div>
		</div>
	);
};

RatingPlace.defaultProps = {
	classes: {},
	rating: "",
	position: "",
};

export default withStyles(styles)(RatingPlace);

export { RatingPlace as __RatingPlace };
